// This file was automatically generated
module.exports = {
    "env": "dev",
    "apiBaseURL": "https://devapi.tasksharp.io",
    "sentryDSN": "",
    "emailManager": {
        "apiBaseURL": "http://devem.tasksharp.io"
    }
};



// WEBPACK FOOTER //
// ./src/config/config.js